import styled from 'styled-components';

import {border, buttonReset, colors} from 'theme';

import {Icon} from '../../Icon';

export const CustomButton = styled.button`
    ${buttonReset};
    background: ${colors.white};
    border: 1px solid ${colors.border};
    border-radius: ${border.radius};
    min-height: 40px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 14px 20px;
    font-size: 12px;
    color: ${colors.textPrimary};

    &:focus {
        outline: none;
        border-color: ${colors.brandPrimary};

        &:hover {
            border-color: ${colors.brandPrimary};
        }
    }
`;

export const CustomIcon = styled(Icon)<{active?: boolean}>`
    margin-left: 10px;
    vertical-align: baseline;
    transform: rotate(${(p) => (!p.active ? '0' : '180deg')});
`;

export const ButtonsContainer = styled.div`
    display: flex;
    align-items: flex-end;
    padding-top: 20px;
`;

export const FieldWrapper = styled.div`
    margin-top: 12px;
`;
